module.exports = __webpack_public_path__ + "static/media/3.ad79e6fe.jpg";